import React from 'react';
import './ListeAffectation.css';

interface DeptRow {
  departement_id: number;
  affecte_id: number | null;
}

interface ListeAffectationProps {
  departements: DeptRow[];
  libelleDept: (id: number) => string;
  couleurParAffecte: Map<number, string>;
  nomParAffecte: Map<number, string>;
  selection: Set<number>;
  onToggle: (departementId: number) => void;
  // Survol d'une personne (roster) : ses lignes ressortent, les autres s'attenuent.
  survoleAffecte?: number | null;
  saving?: boolean;
  // Lecture seule : aucune (de)selection (apercu annuaire), colonne de selection masquee.
  readOnly?: boolean;
}

/**
 * Mode LISTE de l'affectation : meme donnee et meme selection que la carte, en tableau.
 * Chaque ligne = un departement du perimetre ; cliquer la ligne la (de)selectionne. Alternative
 * a la carte pour qui prefere une lecture lineaire (toggle Carte/Liste porte par le parent).
 */
const ListeAffectation: React.FC<ListeAffectationProps> = ({
  departements,
  libelleDept,
  couleurParAffecte,
  nomParAffecte,
  selection,
  onToggle,
  survoleAffecte = null,
  saving = false,
  readOnly = false,
}) => (
  <div className={`liste-affectation${readOnly ? ' is-readonly' : ''}`}>
    <table className="liste-affectation-table">
      <thead>
        <tr>
          <th className="liste-col-sel" aria-label="Sélection" />
          <th>Département</th>
          <th>Interlocuteur</th>
        </tr>
      </thead>
      <tbody>
        {departements.map((d) => {
          const selected = selection.has(d.departement_id);
          const attenue = survoleAffecte != null && d.affecte_id !== survoleAffecte;
          return (
            <tr
              key={d.departement_id}
              className={`liste-row${selected ? ' is-selected' : ''}${attenue ? ' is-attenue' : ''}`}
              onClick={() => { if (!saving && !readOnly) onToggle(d.departement_id); }}
            >
              <td className="liste-col-sel">
                <input type="checkbox" checked={selected} readOnly tabIndex={-1} />
              </td>
              <td>{libelleDept(d.departement_id)}</td>
              <td>
                {d.affecte_id != null ? (
                  <span className="liste-affecte">
                    <span className="liste-affecte-pastille" style={{ background: couleurParAffecte.get(d.affecte_id) }} />
                    {nomParAffecte.get(d.affecte_id) ?? `#${d.affecte_id}`}
                  </span>
                ) : (
                  <span className="liste-non-affecte">Non affecté</span>
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default ListeAffectation;
